import { StandardTextFieldProps, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import './index.css';

interface ITextFieldProps extends StandardTextFieldProps {
	control: Control;
	name: string;
	rules?: any;
}

const ITextField = (props: ITextFieldProps) => {
	const { control, name, rules, defaultValue, ...otherProps } = props;

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue ? defaultValue : ''}
			rules={rules}
			render={({ field, fieldState: { error }, formState }) => (
				<TextField
					className="inputRounded"
					fullWidth
					error={error !== undefined}
					helperText={error ? error.message : undefined}
					{...field}
					{...otherProps}
				/>
			)}
		/>
	);
};

export default ITextField;
